import api from "@/api";
import axios from "@/axios";
import qs from "qs";

const path = "/Alumno";
export default {
    find(obj) {
        return axios.post(`${api.alumnos + path}/Find`, qs.stringify(obj));
    },
};